import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { Avatar, Card, DatePicker, Table, TimePicker, Typography } from "antd";
import CommonSelect from '../../../core/common/commonSelect';
import dayjs from "dayjs";
import { EmploymentType,UserCreateDTO,User, UserUpdateDTO, UserRole, YearlyDetailsForEmployeeResponseDto } from '../../../types/user.types';
import userService from '../../../services/user/user.service';
import { RootState } from '../../../store/store';
import { useSelector } from 'react-redux';
import { 
  DEFAULT_USER_CREATE_DTO, 
  ROLES, 
  GENDERS 
} from '../../../constants/userConstants';
import ReactApexChart from 'react-apexcharts';
import { Salary } from '../../../types/salary.types';
import { ProfileCard } from './components/employeeDetails/ProfileCard';
import LeaveHistory from './components/employeeDetails/LeaveHistory';
import { UserYearlyLeaveSummary } from '../../../types/leaves.types';
import leaveService from '../../../services/leave/leave.service';
import ticketService from '../../../services/ticket/ticket.service';
import { TicketDto } from '../../../types/ticket.types';
import { TicketCards } from '../tickets/ticketsAdmin';
import { FileDto, FileType } from '../../../types/file.types';
import FileService from '../../../services/file/file.service';
import EmployeesDocuments from './components/employeeDetails/EmployeesDocuments';
import AdminLeaveModal from '../../features/leaves/components/AdminLeaveModal';
import { useLeaves } from '../../../hooks/useLeaves';
import { UserRecordDto } from '../../../types/attendanceDto.types';
import dailyRecordService from '../../../services/dailyRecord/dailyRecord.service';
import { handleApiError } from '../../../utils/errorHandler';
import { Trans, useTranslation } from 'react-i18next';
import { useEmployee } from '../../../hooks/useEmployee';
import PersonalInfoStep from './components/form-steps/PersonalInfoStep';
import ContactInfoStep from './components/form-steps/ContactInfoStep';
import WorkInfoStep from './components/form-steps/WorkInfoStep';
import SecurityStep from './components/form-steps/SecurityStep';
import { AnnualLeaveLimitResponse } from '../../../types/company.types';
import 'dayjs/locale/tr';

import { Form, Modal, message, Button } from 'antd';
import companyService from '../../../services/company/company.service';
import FooterSection from '../../shared/components/footerSection';
import { BreakHistoryUserDto } from '../../../types/break.types';
import breakService from '../../../services/break/break.service';
import i18n from '../../../i18n/config';
import datePickerTr from 'antd/lib/date-picker/locale/tr_TR';
import datePickerEn from 'antd/lib/date-picker/locale/en_US';
import LoadingSpinner from '../../shared/uiInterface/base-ui/LoadingSpinner';
import Title from 'antd/es/typography/Title';
import EmployeeAssets from './components/employeeDetails/EmployeeAssets';
type PasswordField = "password" | "confirmPassword";

type EditedAttendanceRecord = {
    entryTime: dayjs.Dayjs | null;
    exitTime: dayjs.Dayjs | null;
    recordId?: number | string | null; // recordId'yi de ekleyelim, çünkü kullanıyoruz
  };
dayjs.locale('tr');

const EmployeeDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formState, setFormState] = useState<UserCreateDTO | UserUpdateDTO>(DEFAULT_USER_CREATE_DTO);
    const [selectedUser, setSelectedUser] = useState<User | null>(null);
    const [activeTab, setActiveTab] = useState<'personal' | 'contact' | 'work' | 'security'>('personal');
    const [userData, setUserData] = useState<User | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [annualLimit, setAnnualLimit] = useState<AnnualLeaveLimitResponse | null>(null);
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const {getTicketsByUser} = ticketService;
    const [yearlyDetails, setYearlyDetails] = useState<YearlyDetailsForEmployeeResponseDto | null>(null);
    const [leaveSummary, setLeaveSummary] = useState<UserYearlyLeaveSummary | null>(null);
    const [passwordVisibility, setPasswordVisibility] = useState({
        password: false,
        confirmPassword: false,
    });
    const [salaries, setSalaries] = useState<Salary[]>([]);
    const [tickets, setTickets] = useState<TicketDto[]>([]);
    const [documents, setDocuments] = useState<FileDto[]>([]);
    const fileService = FileService.getInstance();
    const [isUpdateSalaryModalVisible, setIsUpdateSalaryModalVisible] = useState(false);
    const [newSalaryAmount, setNewSalaryAmount] = useState<number | null>(null);
    const [selectedCurrency, setSelectedCurrency] = useState<string>("TRY");
    const [isUpdatingSalary, setIsUpdatingSalary] = useState(false);
    const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
    const [isLeaveModalVisible, setIsLeaveModalVisible] = useState(false);
    const { createLeave } = useLeaves();
    const [userRecords, setUserRecords] = useState<UserRecordDto>();
    const { getSalaryByUserId, getYearlyDetails } = userService;
    const { getUserYearlyLeaveDetails } = leaveService;
    const [isEditModalVisible, setIsEditModalVisible] = useState(false);
    const [isUpdatingRecord, setIsUpdatingRecord] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState<UserRecordDto['records'][0] | null>(null);
    const [editedRecord, setEditedRecord] = useState<EditedAttendanceRecord | null>(null);
    const [breakHistory, setBreakHistory] = useState<BreakHistoryUserDto[]>([]);
    const [initialFiltersApplied, setInitialFiltersApplied] = useState(false);
    const [loadingStates, setLoadingStates] = useState({
        main: true,
        salary: false,
        tickets: false,
        documents: false,
        userRecords: false,
        breakHistory: false
    });
    const [openAccordions, setOpenAccordions] = useState<Set<string>>(new Set());

    const [formErrors, setFormErrors] = useState<string[]>([]); // Form hatalarını tutmak için state

    const {t} = useTranslation();
    const currencies = [
        { value: "TRY", label: "₺ TL", symbol: "₺" },
        { value: "USD", label: "$ USD", symbol: "$" },
        { value: "EUR", label: "€ EUR", symbol: "€" }
    ];
    const { companyId } = useSelector((state: RootState) => state.auth);
    const {    
        departments,
        shops,
        fetchDepartmentsAndShops,
        updateEmployee,
    } = useEmployee();
   
      const handleEdit = (user: User) => {
    
        form.resetFields();
        setSelectedUser(user);
        
        // Form değerlerini doğru şekilde set et
        const formValues = {
          ...user,
          departmentId: user.department?.map(d => d.id), // department ID'sini set et
          branchId: user.branch?.map(b => b.id), // branch ID'sini set et
          birthDate: user.birthDate ? dayjs(user.birthDate) : null,
          hireDate: user.hireDate ? dayjs(user.hireDate) : null,
          role: user.role || UserRole.USER,
        };
    
        form.setFieldsValue(formValues);
        
        setIsModalOpen(true);
      };

      
    // const fetchUserRecords = async () => {
    //   const startDate = dayjs().startOf('month').format('YYYY-MM-DD');
    //   const endDate = dayjs().endOf('month').format('YYYY-MM-DD');
    //   const userRecords = await dailyRecordService.getUserRecords(Number(id), startDate, endDate);
    //   setUserRecords(userRecords);
    // };

    const breakColumns = [
        {
          title: t('employeesDetail.breaksTable.date', "Tarih"),
          dataIndex: 'startTime',
          key: 'date',
          render: (text: string) => dayjs(text).format('DD.MM.YYYY'),
        },
        {
          title: t('employeesDetail.breaksTable.type', "Mola Tipi"),
          dataIndex: 'type',
          key: 'type',
          render: (text: string) => t(`breakTypes.${text}`, text), // breakTypes.{typeKey} şeklinde çeviri anahtarı varsayılıyor
        },
        {
          title: t('employeesDetail.breaksTable.startTime', "Başlangıç"),
          dataIndex: 'startTime',
          key: 'startTime',
          render: (text: string) => dayjs(text).format('HH:mm'),
        },
        {
          title: t('employeesDetail.breaksTable.endTime', "Bitiş"),
          dataIndex: 'endTime',
          key: 'endTime',
          render: (text: string | null) => text ? dayjs(text).format('HH:mm') : '-',
        },
        {
          title: t('employeesDetail.breaksTable.duration', "Süre"),
          dataIndex: 'breakDuration',
          key: 'duration',
          render: (minutes: number) => formatBreakDuration(minutes),
        },
      ];

    const pickerLocale = useMemo(() => { // pickerLocale'in tanımlı olduğundan emin ol
        return i18n.language === 'tr' ? datePickerTr : datePickerEn;
      }, [i18n.language]);
    
      // Mola süresini formatlamak için yardımcı fonksiyon
      const formatBreakDuration = useCallback((minutes: number): string => {
        if (isNaN(minutes) || minutes < 0) return "-";
        const h = Math.floor(minutes / 60);
        const m = minutes % 60;
        let durationString = "";
        if (h > 0) {
          durationString += `${h} ${t('common.time.hoursShort', 'sa')}`;
        }
        if (m > 0) {
          if (h > 0) durationString += " ";
          durationString += `${m} ${t('common.time.minutesShort', 'dk')}`;
        }
        if (!durationString && minutes === 0) return `0 ${t('common.time.minutesShort', 'dk')}`;
        return durationString || "-";
      }, [t]);


      const fetchCriticalData = useCallback(async () => {
        if (!id) {
            navigate('/');
            return;
        }

        const userId = Number(id);
        if (isNaN(userId)) {
            navigate('/');
            return;
        }

        setLoadingStates(prev => ({ ...prev, main: true }));
        setError(null);

        try {
            // Kritik verileri parallel çek
            const [userData, yearlyDetails, leaveSummary, annualLimitData] = await Promise.all([
                userService.getUserById(userId),
                getYearlyDetails(userId),
                getUserYearlyLeaveDetails(userId),
                companyId ? companyService.getAnnualLimit(Number(companyId)) : null
            ]);

            setUserData(userData);
            setYearlyDetails(yearlyDetails);
            setLeaveSummary(leaveSummary);
            if (annualLimitData) setAnnualLimit(annualLimitData);

            // Departments ve shops'ı da paralel çek
            await fetchDepartmentsAndShops();
            await fetchTickets();
            await fetchDocuments();
            await fetchUserRecords();
            await fetchBreakHistory();

        } catch (error: any) {
            handleApiError(error, t);
        } finally {
            setLoadingStates(prev => ({ ...prev, main: false }));
        }
    }, [id, navigate, getYearlyDetails, getUserYearlyLeaveDetails, companyId, fetchDepartmentsAndShops, t]);

    const fetchSalaries = useCallback(async () => {
        if (!id || salaries.length > 0) return; // Zaten çekilmişse tekrar çekme
        
        setLoadingStates(prev => ({ ...prev, salary: true }));
        try {
            const data = await getSalaryByUserId(Number(id));
            setSalaries(data);
        } catch (error: any) {
            handleApiError(error, t);
        } finally {
            setLoadingStates(prev => ({ ...prev, salary: false }));
        }
    }, [id, getSalaryByUserId, t, salaries.length]);

    const fetchTickets = useCallback(async () => {
        if (!id || tickets.length > 0) return;
        
        setLoadingStates(prev => ({ ...prev, tickets: true }));
        try {
            const data = await getTicketsByUser(Number(id));
            setTickets(data);
        } catch (error: any) {
            handleApiError(error, t);
        } finally {
            setLoadingStates(prev => ({ ...prev, tickets: false }));
        }
    }, [id, getTicketsByUser, t, tickets.length]);

    const fetchDocuments = useCallback(async () => {
        if (!id || documents.length > 0) return;
        
        setLoadingStates(prev => ({ ...prev, documents: true }));
        try {
            const data = await fileService.getFileByUserDocuments(FileType.DOCUMENT, Number(id));
            setDocuments(data);
        } catch (error: any) {
            handleApiError(error, t);
        } finally {
            setLoadingStates(prev => ({ ...prev, documents: false }));
        }
    }, [id, documents.length, t]);

    const [startDateUserRecords, setStartDateUserRecords] = useState<string>(dayjs().startOf('week').format('YYYY-MM-DD'));
    const [endDateUserRecords, setEndDateUserRecords] = useState<string>(dayjs().endOf('week').format('YYYY-MM-DD'));
    const [startDateLeave, setStartDateLeave] = useState<string>(dayjs().startOf('month').format('YYYY-MM-DD'));
    const [endDateLeave, setEndDateLeave] = useState<string>(dayjs().endOf('month').format('YYYY-MM-DD'));
    const fetchUserRecords = useCallback(async () => {
        if (!id || userRecords) return;
        
        setLoadingStates(prev => ({ ...prev, userRecords: true }));
        try {
            const data = await dailyRecordService.getUserRecords(Number(id), startDateUserRecords, endDateUserRecords);
            setUserRecords(data);
        } catch (error: any) {
            handleApiError(error, t);
        } finally {
            setLoadingStates(prev => ({ ...prev, userRecords: false }));
        }
    }, [id, userRecords, t]);

    const fetchBreakHistory = useCallback(async () => {
        if (!id || breakHistory.length > 0) return;
        
        setLoadingStates(prev => ({ ...prev, breakHistory: true }));
        try {
            const data = await breakService.getBreakHistoryUser(
                dayjs().format('YYYY-MM-DD'), 
                dayjs().format('YYYY-MM-DD'), 
                Number(id)
            );
            setBreakHistory(data);
        } catch (error: any) {
            handleApiError(error, t);
        } finally {
            setLoadingStates(prev => ({ ...prev, breakHistory: false }));
        }
    }, [id, breakHistory.length, t]);

     // Accordion açılma handler'ı
     const handleAccordionToggle = useCallback((accordionId: string) => {
        setOpenAccordions(prev => {
            const newSet = new Set(prev);
            if (newSet.has(accordionId)) {
                newSet.delete(accordionId);
            } else {
                newSet.add(accordionId);
                
                // Accordion'a göre lazy loading
                switch (accordionId) {
                    case 'attendance':
                        fetchUserRecords();
                        break;
                    case 'requests':
                        fetchTickets();
                        break;
                    case 'salary':
                        fetchSalaries();
                        break;
                    case 'break':
                        fetchBreakHistory();
                        break;
                    case 'documents':
                        fetchDocuments();
                        break;
                }
            }
            return newSet;
        });
    }, [fetchUserRecords, fetchTickets, fetchSalaries, fetchBreakHistory, fetchDocuments]);

    // İlk yükleme
    useEffect(() => {
        fetchCriticalData();
    }, [fetchCriticalData]);

    // Documents'ı hemen yükle (görünür olduğu için)
    useEffect(() => {
        if (userData) {
            fetchDocuments();
        }
    }, [userData, fetchDocuments]);

    const renderAttendanceAccordion = useCallback(() => {
        if (!openAccordions.has('attendance') && !userRecords) {
            return null; // Accordion kapalıysa ve veri yoksa render etme
        }

        return (
            <div className="accordion-body">
                {loadingStates.userRecords ? (
                    <LoadingSpinner centered />
                ) : (
                    // ... mevcut attendance content ...
                    <div className="row">
                        {/* Attendance content buraya gelecek */}
                    </div>
                )}
            </div>
        );
    }, [openAccordions, userRecords, loadingStates.userRecords]);


    const showModal = () => {
        resetForm();
        setIsModalOpen(true);
      };
    
      const handleCancel = () => {
        setIsModalOpen(false);
        resetForm();
      };
    // useEffect(() => {
    //   fetchUserRecords();
    // }, [id]);

    // const fetchTickets = async () => {
    //   try {
    //     const data = await getTicketsByUser(Number(id));
    //     setTickets(data);
    //     setLoading(false);
    //   } catch (err: any) {
    //     handleApiError(err,t);
    //     setLoading(false);
    //   }
    // };  
    // useEffect(() => {
    //   fetchTickets();
    // }, [id]);
    // const fetchSalaries = async () => {
    //     const salaries = await getSalaryByUserId(Number(id));
    //     console.log(salaries);
    //     setSalaries(salaries);
    // };
    // useEffect(() => {
    //     fetchSalaries();
    // }, [id]);

    // const fetchDocuments = async () => {
    //     const documents = await fileService.getFileByUserDocuments(FileType.DOCUMENT,Number(id));
    //     setDocuments(documents);
    // };
    // useEffect(() => {
    //     fetchDocuments();
    // }, [id]);

    const fetchYearlyDetails = async () => {
        const yearlyDetails = await getYearlyDetails(Number(id));
        setYearlyDetails(yearlyDetails);
    };
    // useEffect(() => {
    //     fetchYearlyDetails();
    //   }, [id]);

    const fetchLeaveSummary = async () => {
        const leaveSummary = await getUserYearlyLeaveDetails(Number(id));
        setLeaveSummary(leaveSummary);
    };
    // useEffect(() => {
    //     fetchLeaveSummary();
    // }, [id]);

    const handleInputChange = (field: keyof (UserCreateDTO | UserUpdateDTO), value: any) => {
        setFormState((prev) => ({ ...prev, [field]: value }));
      };

      const formatMinutesToTimeUnits = (totalMinutes: number | undefined): string => {
        // Geçersiz değerler için kontrol
        if (!totalMinutes || isNaN(totalMinutes) || totalMinutes < 0) {
          return '0 dk';
        }
      
        // 0 dakika
        if (totalMinutes === 0) {
          return '0 dk';
        }
      
        // Zaman birimi tanımları (dakika cinsinden)
        const MINUTE = 1;
        const HOUR = 60;
        const DAY = 60 * 24; // 1440 dakika
        const MONTH = 60 * 24 * 30; // 43200 dakika (30 gün)
        const YEAR = 60 * 24 * 365; // 525600 dakika (365 gün)
      
        let remaining = totalMinutes;
        const parts: string[] = [];
      
        // Yıl hesapla
        if (remaining >= YEAR) {
          const years = Math.floor(remaining / YEAR);
          parts.push(`${years} yıl`);
          remaining = remaining % YEAR;
        }
      
        // Ay hesapla
        if (remaining >= MONTH) {
          const months = Math.floor(remaining / MONTH);
          parts.push(`${months} ay`);
          remaining = remaining % MONTH;
        }
      
        // Gün hesapla
        if (remaining >= DAY) {
          const days = Math.floor(remaining / DAY);
          parts.push(`${days} gün`);
          remaining = remaining % DAY;
        }
      
        // Saat hesapla
        if (remaining >= HOUR) {
          const hours = Math.floor(remaining / HOUR);
          parts.push(`${hours} sa`);
          remaining = remaining % HOUR;
        }
      
        // Dakika hesapla
        if (remaining > 0) {
          parts.push(`${remaining} dk`);
        }
      
        // En fazla 2 birim göster (daha okunabilir olması için)
        return parts.slice(0, 2).join(' ');
      };

    const renderModalContent = () => {

        const hasErrorInTab = (tabName: 'personal' | 'contact' | 'work' | 'security'): boolean => {
            const fieldsPerTab = {
              personal: ['firstName', 'lastName', 'birthDate', 'nationalId', 'gender', 'maritalStatus', 'educationLevel'],
              contact: ['city', 'district', 'address', 'email', 'phone', 'emergencyContact'],
              work: ['departmentId', 'branchId', 'annualLeaveLimit', 'isFixedShift', 'hireDate'],
              security: ['password', 'role', 'title', 'isFaceIdAllow']
            };
            
            return fieldsPerTab[tabName].some(fieldName => 
              form.getFieldError(fieldName)?.length > 0
            );
          };
      
        return (
          <Form 
            form={form} 
            layout="vertical" 
            initialValues={selectedUser || {}}
          >
            {formErrors.length > 0 && ( // Genel hata mesajlarını göster
                <div className="alert alert-danger mb-3" role="alert">
                    <ul style={{paddingLeft: '20px', marginBottom: '0'}}>
                    {formErrors.map((err, index) => (
                        <li key={index}>{err}</li>
                    ))}
                    </ul>
                </div>
            )}
            <div className="contact-grids-tab">
              <ul className="nav nav-underline" id="myTab" role="tablist">
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === 'personal' ? 'active' : ''} ${hasErrorInTab('personal') ? 'tab-has-error' : ''}`}
                    onClick={() => setActiveTab('personal')}
                    type="button"
                    role="tab"
                  >
                    {t('employees.modals.personal')} {hasErrorInTab('personal') && <i className="ti ti-alert-circle text-danger ms-1"></i>}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === 'contact' ? 'active' : ''} ${hasErrorInTab('contact') ? 'tab-has-error' : ''}`}
                    onClick={() => setActiveTab('contact')}
                    type="button"
                    role="tab"
                  >
                    {t('employees.modals.contact')} {hasErrorInTab('contact') && <i className="ti ti-alert-circle text-danger ms-1"></i>}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === 'work' ? 'active' : ''} ${hasErrorInTab('work') ? 'tab-has-error' : ''}`}
                    onClick={() => setActiveTab('work')}
                    type="button"
                  >
                    {t('employees.modals.work')} {hasErrorInTab('work') && <i className="ti ti-alert-circle text-danger ms-1"></i>}
                  </button>
                </li>
                <li className="nav-item" role="presentation">
                  <button
                    className={`nav-link ${activeTab === 'security' ? 'active' : ''} ${hasErrorInTab('security') ? 'tab-has-error' : ''}`}
                    onClick={() => setActiveTab('security')}
                    type="button"
                    role="tab"
                  >
                    {t('employees.modals.security')} {hasErrorInTab('security') && <i className="ti ti-alert-circle text-danger ms-1"></i>}
                  </button>
                </li>
              </ul>
            </div>
            <div className="modal-body">
              {/* Tüm form alanlarını her zaman render et, sadece görünürlüğü değiştir */}
              <div style={{ display: activeTab === 'personal' ? 'block' : 'none' }}>
                <PersonalInfoStep form={form} />
              </div>
              <div style={{ display: activeTab === 'contact' ? 'block' : 'none' }}>
                <ContactInfoStep form={form} />
              </div>
              <div style={{ display: activeTab === 'work' ? 'block' : 'none' }}>
                <WorkInfoStep form={form} departments={departments} shops={shops} annualLimit={annualLimit?.annualLeaveLimit || 0} />
              </div>
              <div style={{ display: activeTab === 'security' ? 'block' : 'none' }}>
                <SecurityStep form={form} isEdit={!!selectedUser} />
              </div>
            </div>
          </Form>
        );
      };
    const sLineArea = {
        chart: {
            height: 350,
            type: "line" as const,
            toolbar: {
                show: false,
                tools: {
                    download: false,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false,
                    selection: false
                }
            }
        },
        colors: ['#4361ee'],
        dataLabels: {
            enabled: true,
            formatter: function(val: number) {
                return currencies.find(c => c.value === selectedCurrency)?.symbol + val.toLocaleString('tr-TR')
            },
            style: {
                fontSize: '14px',
                fontWeight: 600
            },
            background: {
                enabled: true,
                foreColor: '#333',
                padding: 4,
                borderRadius: 4,
                borderWidth: 1,
                borderColor: '#eee',
                opacity: 0.9
            }
        },
        stroke: {
            curve: 'smooth' as const,
            width: 3
        },
        series: [
            {
                name: t('employeesDetail.salary'),
                data: [...salaries]
                    .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
                    .map(salary => salary.amount)
            }
        ],
        grid: {
            borderColor: '#f1f1f1',
            strokeDashArray: 4,
            xaxis: {
                lines: {
                    show: true
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            }
        },
        xaxis: {
            categories: [...salaries]
                .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
                .map(salary => {
                    const date = new Date(salary.createdAt);
                    return date.toLocaleDateString('tr-TR', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                    });
                }),
            labels: {
                style: {
                    fontSize: '12px',
                    fontFamily: 'inherit',
                    fontWeight: 500
                },
                rotate: -45
            }
        },
        yaxis: {
            labels: {
                formatter: function(val: number) {
                    return currencies.find(c => c.value === selectedCurrency)?.symbol + val.toLocaleString('tr-TR')
                },
                style: {
                    fontSize: '12px',
                    fontFamily: 'inherit',
                    fontWeight: 500
                }
            },
            title: {
                text: t('employeesDetail.salaryAmount'),
                style: {
                    fontSize: '13px',
                    fontWeight: 600,
                    fontFamily: 'inherit'
                }
            }
        },
        markers: {
            size: 6,
            strokeWidth: 2,
            fillOpacity: 1,
            strokeOpacity: 1,
            hover: {
                size: 8
            }
        },
        title: {
            text: t('employeesDetail.salaryChangeReport'),
            align: 'left' as const,
            style: {
                fontSize: '16px',
                fontWeight: 600,
                fontFamily: 'inherit',
                color: '#333'
            }
        }
    }

    const { getUserById } = userService;

    // Tarih formatlamak için yardımcı fonksiyon
    const formatDate = (dateString: string | Date | undefined) => {
        if (!dateString) return '-'; // Boş değer için tire işareti
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString();
        } catch (error) {
            return '-';
        }
    };

    
    const formatDurationFromMinutes = (minutes: number, t?: (key: string, fallback: string) => string): string => {
        if (isNaN(minutes) || minutes < 0) {
          return "-";
        }
        if (minutes === 0) {
          return `0 ${t ? t('common.time.minutesShort', 'dk') : 'dk'}`;
        }
      
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
      
        let durationString = "";
      
        if (hours > 0) {
          durationString += `${hours} ${t ? t('common.time.hoursShort', 'sa') : 'sa'}`;
        }
      
        if (remainingMinutes > 0) {
          if (hours > 0) {
            durationString += " "; // Saat ve dakika arasında boşluk
          }
          durationString += `${remainingMinutes} ${t ? t('common.time.minutesShort', 'dk') : 'dk'}`;
        }
      
        return durationString;
      };

    const fetchUserData = async () => {
      // ID kontrolü
      const userId = Number(id);
      if (isNaN(userId)) {
        navigate('/');
        return;
      }
      
      setLoading(true);
      setError(null);
      
      try {
        const response = await getUserById(userId);
        setUserData(response);
      } catch (error: any) {
        handleApiError(error,t);
      } finally {
        setLoading(false);
      }
    };
    


    // useEffect(() => {
    //     fetchUserData();
    // }, [id, navigate]);
const handleFormSubmit = async () => {
    setFormErrors([]); // Önceki hataları temizle

    try {
      const values = await form.validateFields();
      
      const formData: UserCreateDTO | UserUpdateDTO = {
        ...values,
        department: values.departmentId,
        branch: values.branchId,
        birthDate: values.birthDate ? dayjs(values.birthDate).format('YYYY-MM-DD') : undefined,
        hireDate: values.hireDate ? dayjs(values.hireDate).format('YYYY-MM-DD') : new Date().toISOString(),
        role: UserRole.USER,
      };

      await updateEmployee(Number(id), formData);
      setIsModalOpen(false);
      resetForm();
      await fetchUserData();
    } catch (errorInfo: any) {
        // handleApiError(error,t); // Bu satırı yorumladım, çünkü Ant Design'ın kendi hata yönetimini kullanacağız
        if (errorInfo.errorFields && errorInfo.errorFields.length > 0) {
          const errorMessages = errorInfo.errorFields.map((field: any) => field.errors.join(', '));
          setFormErrors(errorMessages); // Hata mesajlarını state'e kaydet
          message.error(t('employees.validationErrors.fillRequiredFields')); // Genel hata mesajı
  
          const firstErrorField = errorInfo.errorFields[0].name.join('.'); // AntD field path'ini al
  
          // Hangi sekmede hata olduğunu belirle
          // Bu kısım form alanlarının hangi sekmede olduğuna göre özelleştirilmeli
          // Örnek: PersonalInfoStep alanları
          const personalInfoFields = ['firstName', 'lastName', 'birthDate', 'nationalId', 'gender', 'maritalStatus', 'educationLevel'];
          // Örnek: ContactInfoStep alanları
          const contactInfoFields = ['city', 'district', 'address', 'email', 'phone', 'emergencyContact'];
          // Örnek: WorkInfoStep alanları
          const workInfoFields = ['departmentId', 'branchId', 'annualLeaveLimit', 'isFixedShift', 'hireDate'];
          // Örnek: SecurityStep alanları
          const securityInfoFields = ['password', 'role', 'title', 'isFaceIdAllow'];
  
          let errorTab = activeTab; // Varsayılan olarak mevcut tab
  
          if (personalInfoFields.some(field => firstErrorField.startsWith(field))) {
            errorTab = 'personal';
          } else if (contactInfoFields.some(field => firstErrorField.startsWith(field))) {
            errorTab = 'contact';
          } else if (workInfoFields.some(field => firstErrorField.startsWith(field))) {
            errorTab = 'work';
          } else if (securityInfoFields.some(field => firstErrorField.startsWith(field))) {
            errorTab = 'security';
          }
          
          setActiveTab(errorTab); // Hatalı sekmeye geç
          
          // Hatalı alana scroll yap (kısa bir gecikmeyle daha iyi çalışabilir)
          setTimeout(() => {
            form.scrollToField(firstErrorField, {
              behavior: 'smooth',
              block: 'center', // Ortalamak daha iyi olabilir
            });
          }, 100);
  
        } else {
          // API'den gelen veya beklenmedik bir hata ise
          handleApiError(errorInfo, t);
        }
      }
  };
  const resetForm = () => {
    setSelectedUser(null);
    setActiveTab('personal');
    form.resetFields();
    form.setFieldsValue({
      firstName: '',
      lastName: '',
      birthDate: null,
      nationalId: '',
      gender: undefined,
      maritalStatus: undefined,
      educationLevel: undefined,
      email: '',
      phone: '',
      address: '',
      city: '',
      title: '',
      emergencyContact: '',
      departmentId: undefined,
      branchId: undefined,
      position: '',
      username: '',
      password: '',
    });
  };
  
    const handleUpdateSalary = async () => {
        if (!newSalaryAmount || newSalaryAmount <= 0) {
            message.error(t('employeesDetail.enterValidSalary'));
            return;
        }

        setIsConfirmModalVisible(true);
    };

    const handleConfirmUpdate = async () => {
        try {
            setIsUpdatingSalary(true);
            await userService.updateSalary(Number(id), newSalaryAmount!);
            await fetchSalaries();
            setIsUpdateSalaryModalVisible(false);
            setIsConfirmModalVisible(false);
            message.success(t('employeesDetail.salaryUpdatedSuccessfully'));
            setNewSalaryAmount(null);
            setSelectedCurrency("TRY");
            await fetchUserData();
        } catch (error: any) {
            handleApiError(error,t);
        } finally {
            setIsUpdatingSalary(false);
        }
    };

    const calculateSalaryChange = () => {
        if (!newSalaryAmount || salaries.length === 0) return null;
        const currentSalary = salaries[0].amount;
        const change = ((newSalaryAmount - currentSalary) / currentSalary) * 100;
        return {
            percentage: change.toFixed(2),
            isIncrease: change > 0,
            difference: Math.abs(newSalaryAmount - currentSalary).toLocaleString('tr-TR')
        };
    };

    const handleLeaveSubmit = async (values: any) => {
        try {
            await createLeave({
                ...values,
                employeeId: Number(id) // Seçili kullanıcının ID'si
            });
            message.success(t('employeesDetail.leaveCreatedSuccessfully'));
            setIsLeaveModalVisible(false);
            fetchUserData(); // Kullanıcı verilerini yenile
        } catch (error: any) {
            handleApiError(error,t);
        }
    };

    const handleEditRecord = (record: any) => {
        setSelectedRecord(record);
        setEditedRecord({
            ...record,
            entryTime: record.entryTime ? dayjs(record.entryTime) : null,
            exitTime: record.exitTime ? dayjs(record.exitTime) : null,
            recordId: record.recordId
        });

        setIsEditModalVisible(true);
    };

    const handleUpdateRecord = async () => {
        if (!editedRecord || !editedRecord.entryTime) {
            message.error(t('employeesDetail.invalidEntryTime', "Geçerli bir giriş saati gereklidir."));
            return;
        }

        const recordId = selectedRecord?.recordId;
        if (!recordId) {
            message.error(t('employeesDetail.recordIdMissing', "Kayıt ID'si bulunamadı."));
            return;
        }
        // return dayjs(timeString).locale("tr").format("DD.MM.YYYY / HH:mm");

        const finalEntryTime = editedRecord.entryTime.format('YYYY-MM-DD HH:mm:ss');
        let finalExitTime: string | null = null;
        
        if (editedRecord.exitTime) {
            // Çıkış saati, giriş saatinden sonra olmalı kontrolü
            if (editedRecord.exitTime.isSameOrBefore(editedRecord.entryTime)) {
                message.error(t('employeesDetail.exitTimeAfterEntryTimeError', "Çıkış saati, giriş saatinden sonra olmalıdır."));
                return;
            }
            finalExitTime = editedRecord.exitTime.format('YYYY-MM-DD HH:mm:ss');
        }
        // Eğer editedRecord.exitTime null ise, finalExitTime da null kalacak.
        // Bu durumda backend'e null gönderilecek.

        setIsUpdatingRecord(true);
        try {
            await dailyRecordService.updateRecordTime(recordId, finalEntryTime, finalExitTime ? finalExitTime : undefined);
            message.success(t('employeesDetail.recordUpdatedSuccessfully'));
            setIsEditModalVisible(false);
            fetchUserRecords(); // Kayıtları yenile
        } catch (error: any) {
            handleApiError(error,t);
        } finally {
            setIsUpdatingRecord(false);
        }
    };

    const handleDeviceReset = async () => {
        try {
            await userService.resetDevice(Number(id));
            message.success(t('employeesDetail.deviceResetSuccessfully'));
        } catch (error: any) {
            handleApiError(error,t);
        }
    };
    
    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                {loadingStates.main && <LoadingSpinner centered />}

                {error && (
                    <div className="alert alert-danger mx-4 my-4" role="alert">
                        <div className="d-flex align-items-center">
                            <i className="ti ti-alert-circle me-2"></i>
                            {error}
                        </div>
                    </div>
                )}

                {!loadingStates.main && !error && userData && (
                    <>
                        <div className="row">
                            <div className="col-xl-4 theiaStickySidebar">
                                <ProfileCard userData={userData} formatDate={formatDate} onEdit={handleEdit} onDeviceReset={handleDeviceReset}/>
                            </div>
                            
                            <div className="col-xl-8">
                                <div>
                                    <div className="tab-content custom-accordion-items">
                                        <div
                                            className="tab-pane active show"
                                            id="bottom-justified-tab1"
                                            role="tabpanel"
                                        >
                                            <div
                                                className="accordion accordions-items-seperate"
                                                id="accordionExample"
                                            >
                                                <div className="col-xl-12 col-lg-8 d-flex">
                        <div className="row flex-fill d-flex justify-content-between">
                          {/* Toplam Çalışma Günü */}
                          <div className="col-xl-4 col-md-4">
                            <div className="card">
                              <div className="card-body text-center p-3">
                                <h2 className="mb-2 d-flex align-items-center justify-content-center">
                                  <span className="avatar avatar-xs bg-primary me-2">
                                    <i className="ti ti-calendar" />
                                  </span>
                                  {yearlyDetails?.workDays}
                                </h2>
                                <p className="fw-medium mb-0">{t('employeesDetail.totalWorkingDays')}</p>
                              </div>
                            </div>
                          </div>
                          {/* Toplam Geç Kalınan Gün */}
                          <div className="col-xl-4 col-md-4">
                            <div className="card">
                              <div className="card-body text-center p-3">
                                <h2 className="mb-2 d-flex align-items-center justify-content-center">
                                  <span className="avatar avatar-xs bg-danger me-2">
                                    <i className="ti ti-alarm" />
                                  </span>
                                  {yearlyDetails?.lateDays}
                                </h2>
                                <p className="fw-medium mb-0">{t('employeesDetail.totalLateDays')}</p>
                              </div>
                            </div>
                          </div>
                          {/* Toplam İzin Günü */}
                          <div className="col-xl-4 col-md-4">
                            <div className="card">
                              <div className="card-body text-center p-3">
                                <h2 className="mb-2 d-flex align-items-center justify-content-center">
                                  <span className="avatar avatar-xs bg-info me-2">
                                    <i className="ti ti-user-off" />
                                  </span>
                                  {yearlyDetails?.leaveDays}
                                </h2>
                                <p className="fw-medium mb-0">{t('employeesDetail.totalLeaveDays')}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <EmployeesDocuments documents={documents} userData={userData}/>
                                               {/* <EmployeesDocuments documents={ userData?.documents || []} /> */}
                                                <LeaveHistory 
                                                    leaves={userData?.leaves?.filter((leave) => {
                                                        const leaveStart = dayjs(leave.startDate);
                                                        const leaveEnd = dayjs(leave.endDate);
                                                        const filterStart = dayjs(startDateLeave);
                                                        const filterEnd = dayjs(endDateLeave);
                                                        
                                                        // İzin tarihleri filtre aralığı ile kesişiyor mu kontrol et
                                                        return (leaveStart.isBetween(filterStart, filterEnd, 'day', '[]') || 
                                                                leaveEnd.isBetween(filterStart, filterEnd, 'day', '[]') ||
                                                                (leaveStart.isSameOrBefore(filterStart, 'day') && leaveEnd.isSameOrAfter(filterEnd, 'day')));
                                                    }) || []} 
                                                    formatDate={formatDate} 
                                                    leaveSummary={leaveSummary as UserYearlyLeaveSummary}
                                                    onCreateLeave={() => setIsLeaveModalVisible(true)}
                                                    userData={userData}
                                                    startDateLeave={startDateLeave}
                                                    endDateLeave={endDateLeave}
                                                />
                                                
                                                <EmployeeAssets 
                                                    userData={userData}
                                                />
                                                
                                                <div className="accordion-item">
                                                    <div className="accordion-header" id="headingThree">
                                                        <div 
                                                        className="accordion-button collapsed"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#primaryBorderThree"
                                                        aria-expanded="false"
                                                        aria-controls="primaryBorderThree"
                                                        style={{ cursor: 'pointer' }}
                                                        >
                                                            <div className="d-flex align-items-center justify-content-between flex-fill">
                                                                <h5>{t('employeesDetail.attendanceStatus')}</h5>
                                                                <div className="d-flex">
                                                                    <i className="ti ti-chevron-down fs-18" />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        id="primaryBorderThree"
                                                        className="accordion-collapse collapse border-top"
                                                        aria-labelledby="headingThree"
                                                        data-bs-parent="#accordionExample"
                                                    >
                                                        <div className="accordion-body">
                                                            <div className="row">
                                                                <div className="col-xl-12">
                                                                    {/* Özet Kartları */}
                                                                    <div className="row mb-4">
                                                                        <div className="col-xl-3 col-md-6">
                                                                            <div className="card h-100 border-0 shadow-sm hover-shadow">
                                                                                <div className="card-body text-center p-4">
                                                                                    <div className="mb-4">
                                                                                        <div className="avatar avatar-xl bg-primary-subtle rounded-circle d-inline-flex align-items-center justify-content-center">
                                                                                            <span className="fs-2">⏰</span>
                                                                                        </div>
                                                                                    </div>
                                                                                <h2 className="mb-2 text-primary">
                                                                                    {formatMinutesToTimeUnits(userRecords?.totalWorkMinutes)}
                                                                                </h2>
                                                                                    <p className="fw-medium mb-0 text-muted">{t('employeesDetail.totalWorking')}</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-xl-3 col-md-6">
                                                                            <div className="card h-100 border-0 shadow-sm hover-shadow">
                                                                                <div className="card-body text-center p-4">
                                                                                    <div className="mb-4">
                                                                                        <div className="avatar avatar-xl bg-danger-subtle rounded-circle d-inline-flex align-items-center justify-content-center">
                                                                                            <span className="fs-2">⚠️</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <h2 className="mb-2 text-danger">{userRecords?.lateDaysCount}</h2>
                                                                                    <p className="fw-medium mb-0 text-muted">Toplam Geç Kalınan Gün</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-xl-3 col-md-6">
                                                                            <div className="card h-100 border-0 shadow-sm hover-shadow">
                                                                                <div className="card-body text-center p-4">
                                                                                    <div className="mb-4">
                                                                                        <div className="avatar avatar-xl bg-warning-subtle rounded-circle d-inline-flex align-items-center justify-content-center">
                                                                                            <span className="fs-2">🏃</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <h2 className="mb-2 text-warning">{userRecords?.earlyLeaveDaysCount}</h2>
                                                                                    <p className="fw-medium mb-0 text-muted">Toplam Erken Çıkılan Gün</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-xl-3 col-md-6">
                                                                            <div className="card h-100 border-0 shadow-sm hover-shadow">
                                                                                <div className="card-body text-center p-4">
                                                                                    <div className="mb-4">
                                                                                        <div className="avatar avatar-xl bg-success-subtle rounded-circle d-inline-flex align-items-center justify-content-center">
                                                                                            <span className="fs-2">🗓️</span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <h2 className="mb-2 text-success">{userRecords?.totalRecords}</h2>
                                                                                    <p className="fw-medium mb-0 text-muted">Toplam Çalışma Günü</p>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {/* Devam Tablosu */}
                                                                    <div className="card">
                                                                        <div className="card-header">
                                                                            <h5 className="card-title mb-0">Haftalık Devam Kayıtları</h5>
                                                                            {startDateUserRecords} - {endDateUserRecords}
                                                                        </div>
                                                                        <div className="card-body">
                                                                            <div className="table-responsive">
                                                                                <table className="table table-hover">
                                                                                    <thead>
                                                                                        <tr>
                                                                                            <th>{t('employeesDetail.date')}</th>
                                                                                            <th>{t('employeesDetail.entryTime')}</th>
                                                                                            <th>{t('employeesDetail.exitTime')}</th>
                                                                                            <th>{t('employeesDetail.status')}</th>
                                                                                            <th>{t('employeesDetail.lateDays')}</th>
                                                                                            <th>{t('employeesDetail.workMinutes')}</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {userRecords?.records.map((record, index) => (
                                                                                            <tr 
                                                                                                key={index}
                                                                                                className="cursor-pointer"
                                                                                                onClick={() => handleEditRecord(record)}
                                                                                                style={{ cursor: 'pointer' }}
                                                                                            >
                                                                                                <td>{dayjs(record.entryTime).format('DD.MM.YYYY')}</td>
                                                                                                <td>{dayjs(record.entryTime).format('HH:mm')}</td>
                                                                                                <td>{ record.exitTime ? dayjs(record.exitTime).format('HH:mm') : '--:--'}</td>
                                                                                                <td>
                                                                                                    <span className={`badge ${record.isLate ? 'bg-danger-subtle text-danger' : 'bg-success-subtle text-success'}`}>
                                                                                                        {record.isLate ? t('employeesDetail.lateDays') : t('employeesDetail.onTime')}
                                                                                                    </span>
                                                                                                </td>
                                                                                                <td>{record.isLate ? record.lateDuration : '' }</td>
                                                                                                <td>{Math.floor(record.workMinutes / 60)} {t('employeesDetail.hours')} {record.workMinutes % 60} {t('employeesDetail.minutes')}</td>
                                                                                            </tr>
                                                                                        ))}
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {/* Güncelleme Modalı */}
                                                                    <Modal
                                                                        title={
                                                                            <div className="d-flex align-items-center">
                                                                                <i className="ti ti-edit fs-4 me-2 text-primary"></i>
                                                                                <span>{t('employeesDetail.updateAttendanceRecord')}</span>
                                                                            </div>
                                                                        }
                                                                        open={isEditModalVisible}
                                                                        onCancel={() => setIsEditModalVisible(false)}
                                                                        footer={[
                                                                            <Button 
                                                                                key="cancel" 
                                                                                onClick={() => setIsEditModalVisible(false)}
                                                                            >
                                                                                {t('employeesDetail.cancel')}
                                                                            </Button>,
                                                                            <Button 
                                                                                key="submit" 
                                                                                type="primary" 
                                                                                loading={isUpdatingRecord}
                                                                                onClick={handleUpdateRecord}
                                                                            >
                                                                                {t('employeesDetail.update')}
                                                                            </Button>
                                                                        ]}
                                                                        width={500}
                                                                    >
                                                                        <div className="edit-record-form">
                                                                            <div className="mb-4">
                                                                                <h6 className="text-muted mb-3">{t('employeesDetail.date')}</h6>
                                                                                <div className="p-3 bg-light rounded-3 border">
                                                                                    <p className="mb-0 fw-medium">
                                                                                        {/* Giriş Tarihi (Düzenlenemez) */}
                                                                                        {editedRecord?.entryTime ? editedRecord.entryTime.format('dddd, DD MMMM YYYY') : ''}
                                                                                    </p>
                                                                                </div>
                                                                            </div>
                                                                            <div className="time-picker-container p-4 bg-light rounded-3 border">
                                                                                <div className="d-flex align-items-center mb-4">
                                                                                    <div className="avatar avatar-sm bg-primary-subtle rounded-circle d-inline-flex align-items-center justify-content-center me-2">
                                                                                        <i className="ti ti-clock text-primary"></i>
                                                                                    </div>
                                                                                    <h6 className="mb-0">{t('employeesDetail.workHours')}</h6>
                                                                                </div>
                                                                                <div className="time-display">
                                                                                    <div className="row g-4">
                                                                                        <div className="col-6">
                                                                                            <div className="time-card p-4 bg-white rounded-3 border text-center">
                                                                                                <div className="time-header mb-4">
                                                                                                    <div className="time-icon mb-3">
                                                                                                        <div className="avatar avatar-lg bg-primary-subtle rounded-circle d-inline-flex align-items-center justify-content-center">
                                                                                                            <i className="ti ti-login text-primary fs-4"></i>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <h6 className="text-primary mb-0">{t('employeesDetail.entryTime')}</h6>
                                                                                                </div>
                                                                                                <TimePicker
                                                                                                    className="time-picker-input"
                                                                                                    format="HH:mm"
                                                                                                    value={editedRecord?.entryTime}
                                                                                                    onChange={(time) => {
                                                                                                        if (time && editedRecord?.entryTime) {
                                                                                                            // Sadece saati güncelle, tarihi koru
                                                                                                            const newEntryTime = editedRecord.entryTime
                                                                                                                .hour(time.hour())
                                                                                                                .minute(time.minute())
                                                                                                                .second(0)
                                                                                                                .millisecond(0);
                                                                                                            setEditedRecord({
                                                                                                                ...editedRecord,
                                                                                                                entryTime: newEntryTime
                                                                                                            });
                                                                                                        }
                                                                                                    }}
                                                                                                    minuteStep={1}
                                                                                                    showNow={false}
                                                                                                    allowClear={false} // Giriş saati zorunlu
                                                                                                    placeholder={t('employeesDetail.selectTime')}
                                                                                                    popupClassName="time-picker-popup"
                                                                                                    locale={pickerLocale}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-6">
                                                                                            <div className="time-card p-4 bg-white rounded-3 border text-center">
                                                                                                <div className="time-header mb-4">
                                                                                                    <div className="time-icon mb-3">
                                                                                                        <div className="avatar avatar-lg bg-danger-subtle rounded-circle d-inline-flex align-items-center justify-content-center">
                                                                                                            <i className="ti ti-logout text-danger fs-4"></i>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                    <h6 className="text-danger mb-0">{t('employeesDetail.exitTime')}</h6>
                                                                                                </div>
                                                                                                <DatePicker
                                                                                                    className="time-picker-input" // Aynı stili kullanabiliriz
                                                                                                    showTime={{ format: 'HH:mm' }}
                                                                                                    format="DD.MM.YYYY HH:mm"
                                                                                                    value={editedRecord?.exitTime}
                                                                                                    onChange={(dateTime) => {
                                                                                                        setEditedRecord((prev: EditedAttendanceRecord | null) => 
                                                                                                            prev ? { ...prev, exitTime: dateTime } : null
                                                                                                        );
                                                                                                    }}
                                                                                                    minuteStep={1}
                                                                                                    showNow={false}
                                                                                                    allowClear={true} // Çıkış saati silinebilir
                                                                                                    placeholder={t('employeesDetail.selectDateTimePlaceholder', "Tarih ve saat seçin")}
                                                                                                    locale={pickerLocale}
                                                                                                    // Varsayılan tarihi giriş tarihi olarak ayarla eğer çıkış yoksa
                                                                                                    // DatePicker açıldığında bu değer kullanılır
                                                                                                    // defaultValue={editedRecord?.entryTime && !editedRecord.exitTime ? editedRecord.entryTime : undefined}
                                                                                                    disabledDate={(current) => {
                                                                                                        // Giriş tarihinden önceki tarihleri disable et
                                                                                                        if (!editedRecord?.entryTime) return false;
                                                                                                        return current && current.isBefore(editedRecord.entryTime.startOf('day'));
                                                                                                    }}
                                                                                                    disabledTime={(current) => {
                                                                                                        if (!editedRecord?.entryTime || !current) return {};
                                                                                                        // Eğer seçilen tarih giriş tarihiyle aynıysa, giriş saatinden önceki saatleri disable et
                                                                                                        if (current.isSame(editedRecord.entryTime, 'day')) {
                                                                                                            const entryHour = editedRecord.entryTime.hour();
                                                                                                            const entryMinute = editedRecord.entryTime.minute();
                                                                                                            return {
                                                                                                                disabledHours: () => Array.from({ length: entryHour }, (_, i) => i),
                                                                                                                disabledMinutes: (selectedHour) => {
                                                                                                                    if (selectedHour === entryHour) {
                                                                                                                        return Array.from({ length: entryMinute + 1 }, (_, i) => i);
                                                                                                                    }
                                                                                                                    return [];
                                                                                                                },
                                                                                                            };
                                                                                                        }
                                                                                                        return {};
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <style>
                                                                                {`
                                                                                    .time-picker-container {
                                                                                        transition: all 0.3s;
                                                                                        background: linear-gradient(145deg, #f8f9fa, #ffffff);
                                                                                    }
                                                                                    .time-picker-container:hover {
                                                                                        transform: translateY(-2px);
                                                                                        box-shadow: 0 8px 24px rgba(0,0,0,0.08);
                                                                                    }
                                                                                    .time-card {
                                                                                        transition: all 0.3s;
                                                                                        height: 100%;
                                                                                        background: #ffffff;
                                                                                        border: 1px solid rgba(0,0,0,0.05);
                                                                                    }
                                                                                    .time-card:hover {
                                                                                        transform: translateY(-2px);
                                                                                        box-shadow: 0 4px 16px rgba(0,0,0,0.06);
                                                                                        border-color: rgba(67, 97, 238, 0.2);
                                                                                    }
                                                                                    .time-header {
                                                                                        transition: all 0.3s;
                                                                                    }
                                                                                    .time-icon {
                                                                                        transition: all 0.3s;
                                                                                    }
                                                                                    .time-card:hover .time-icon {
                                                                                        transform: scale(1.05);
                                                                                    }
                                                                                    .time-picker-input {
                                                                                        width: 100%;
                                                                                        height: 48px;
                                                                                        font-size: 1.1rem;
                                                                                        border-radius: 8px;
                                                                                        border: 2px solid #e9ecef;
                                                                                        transition: all 0.3s;
                                                                                    }
                                                                                    .time-picker-input:hover {
                                                                                        border-color: #4361ee;
                                                                                    }
                                                                                    .time-picker-input:focus {
                                                                                        border-color: #4361ee;
                                                                                        box-shadow: 0 0 0 4px rgba(67, 97, 238, 0.1);
                                                                                    }
                                                                                    .time-picker-popup .ant-picker-panel {
                                                                                        border-radius: 8px;
                                                                                    }
                                                                                    .time-picker-popup .ant-picker-time-panel-column {
                                                                                        scrollbar-width: thin;
                                                                                        scrollbar-color: #4361ee #f8f9fa;
                                                                                    }
                                                                                    .time-picker-popup .ant-picker-time-panel-column::-webkit-scrollbar {
                                                                                        width: 6px;
                                                                                    }
                                                                                    .time-picker-popup .ant-picker-time-panel-column::-webkit-scrollbar-track {
                                                                                        background: #f8f9fa;
                                                                                        border-radius: 3px;
                                                                                    }
                                                                                    .time-picker-popup .ant-picker-time-panel-column::-webkit-scrollbar-thumb {
                                                                                        background-color: #4361ee;
                                                                                        border-radius: 3px;
                                                                                    }
                                                                                    .ant-picker-ok {
                                                                                        margin-top: 8px;
                                                                                    }
                                                                                    .ant-picker-ok button {
                                                                                        background-color: #4361ee;
                                                                                        border-color: #4361ee;
                                                                                    }
                                                                                    .ant-picker-ok button:hover {
                                                                                        background-color: #3651d4;
                                                                                        border-color: #3651d4;
                                                                                    }
                                                                                `}
                                                                            </style>
                                                                        </div>
                                                                    </Modal>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="text-center" style={{ marginBottom: "20px" }}>
                                                            <Link to={`/user-attendance?user=${userData.id}`} className="">
                                                                {t('employeesDetail.viewAll')}
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="accordion-item">
                                                    <div className="row">
                                                        <div className="accordion-header" id="headingFour">
                                                            <div className="accordion-button collapsed"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#primaryBorderFour"
                                                            aria-expanded="false"
                                                            aria-controls="primaryBorderFour"
                                                            style={{ cursor: 'pointer' }}
                                                            >
                                                                <div className="d-flex align-items-center justify-content-between flex-fill">
                                                                    <h5>{t('employeesDetail.requests')}</h5>
                                                                    <div className="d-flex">
                                                                        
                                                                        <i className="ti ti-chevron-down fs-18" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            id="primaryBorderFour"
                                                            className="accordion-collapse collapse border-top"
                                                            aria-labelledby="headingFour"
                                                            data-bs-parent="#accordionExample"
                                                        >
                                                            <div className="accordion-body">
                                                                <div className="row">
                                                                    {tickets.map((ticket) => (

                                                                      <TicketCards
                                                                          key={ticket.id}
                                                                          ticketid={ticket.id}
                                                                          ticketmaintitle={ticket.title}
                                                                          ticketdescription={ticket.description}
                                                                          ticketstatus={ticket.status}
                                                                          ticketdate={ticket.createdAt}
                                                                          ticketuser={userData}
                                                                          onTicketUpdate={fetchTickets}
                                                                      />
                                                                    ))}
                                                                </div>
                                                                <div className="text-center">
                                                                    <Link to={`/user-tickets?user=${userData.id}`} className="">
                                                                        {t('employeesDetail.viewAll')}
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="accordion-item">
                                                    <div className="row">
                                                        <div className="accordion-header" id="headingFive">
                                                            <div className="accordion-button collapsed"
                                                                data-bs-toggle="collapse"
                                                                data-bs-target="#primaryBorderFive"
                                                                aria-expanded="false"
                                                                aria-controls="primaryBorderFive"
                                                                style={{ cursor: 'pointer' }}
                                                            >
                                                                <div className="d-flex align-items-center justify-content-between flex-fill">
                                                                    <h5>{t('employeesDetail.salaryChangeReport')}</h5>
                                                                    <div className="d-flex align-items-center">
                                                                        <i className="ti ti-chevron-down fs-18" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            id="primaryBorderFive"
                                                            className="accordion-collapse collapse border-top"
                                                            aria-labelledby="headingFive"
                                                            data-bs-parent="#accordionExample"
                                                        >
                                                            
                                                            <div className="accordion-body">
                                                                <div 
                                                                    className="btn btn-sm btn-primary mb-3"
                                                                    onClick={() => {
                                                                        setIsUpdateSalaryModalVisible(true);
                                                                    }}
                                                                >
                                                                   Maaşı Güncelle
                                                                </div>
                                                                <ReactApexChart
                                                                    options={sLineArea}
                                                                    series={sLineArea.series}
                                                                    type="line"
                                                                    height={350}
                                                                />


                                                                {/* <div>
                                                                    <p>Work in Progress...</p>
                                                                </div> */}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="accordion-item">
                                                    <div className="row">
                                                        <div className="accordion-header" id="headingSix">
                                                            <div className="accordion-button collapsed"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#primaryBorderSix"
                                                            aria-expanded="false"
                                                            aria-controls="primaryBorderSix"
                                                            style={{ cursor: 'pointer' }}
                                                            >
                                                                <div className="d-flex align-items-center justify-content-between flex-fill">
                                                                    <h5>{t('employeesDetail.breakReport')}</h5>
                                                                    <div className="d-flex">
                                                                        <i className="ti ti-chevron-down fs-18" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div
                                                            id="primaryBorderSix"
                                                            className="accordion-collapse collapse border-top"
                                                            aria-labelledby="headingSix"
                                                            data-bs-parent="#accordionExample"
                                                        >
                                                            <div className="accordion-body">
                                                                <div className="row">
                                                                <div className="col-xl-12">

                                                                    <div className="d-flex justify-content-end mb-3">
                                                                        <>
                                                                            {/* Mola Özet Kartları */}
                                                                            {/* <div className="row">
                                                                            <div className="col-xl-4 col-md-6 mb-3">
                                                                                <Card bordered={false} className="h-100 shadow-sm hover-shadow">
                                                                                <div className="text-center p-2">
                                                                                    <Avatar size={64} icon={<i className="ti ti-coffee text-info" style={{fontSize: '32px'}}/>} className="bg-info-subtle mb-3" />
                                                                                    <Title level={3} className="mb-1 text-info">
                                                                                        {formatDurationFromMinutes(breakHistory.reduce((a, b) => a + b.breakDuration, 0))}
                                                                                    </Title>
                                                                                    <Typography.Text type="secondary">{t('employeesDetail.totalBreakTimeCard', "Toplam Mola Süresi")}</Typography.Text>
                                                                                </div>
                                                                                </Card>
                                                                            </div>
                                                                            <div className="col-xl-4 col-md-6 mb-3">
                                                                                <Card bordered={false} className="h-100 shadow-sm hover-shadow">
                                                                                <div className="text-center p-2">
                                                                                    <Avatar size={64} icon={<i className="ti ti-list-numbers text-secondary" style={{fontSize: '32px'}}/>} className="bg-secondary-subtle mb-3" />
                                                                                    <Title level={3} className="mb-1 text-secondary">{breakHistory.length}</Title>
                                                                                    <Typography.Text type="secondary">{t('employeesDetail.totalBreaksTakenCard', "Toplam Alınan Mola")}</Typography.Text>
                                                                                </div>
                                                                                </Card>
                                                                            </div>
                                                                            <div className="col-xl-4 col-md-6 mb-3">
                                                                                <Card bordered={false} className="h-100 shadow-sm hover-shadow">
                                                                                <div className="text-center p-2">
                                                                                    <Avatar size={64} icon={<i className="ti ti-chart-pie text-warning" style={{fontSize: '32px'}}/>} className="bg-warning-subtle mb-3" />
                                                                                    <Title level={3} className="mb-1 text-warning">
                                                                                    {breakHistory.length > 0 
                                                                                        ? formatBreakDuration(Math.round(breakHistory.reduce((a, b) => a + b.breakDuration, 0) / breakHistory.length)) 
                                                                                        : '-'}
                                                                                    </Title>
                                                                                    <Typography.Text type="secondary">{t('employeesDetail.averageBreakTimeCard', "Ortalama Mola Süresi")}</Typography.Text>
                                                                                </div>
                                                                                </Card>
                                                                            </div>
                                                                            </div> */}

                                                                            {/* Mola Kayıtları Tablosu */}
                                                                        </>

                                                                        </div>
                                                                            <Card title="Günlük Mola Kayıtları">
                                                                            {breakHistory && breakHistory.length > 0 ? (
                                                                                <Table
                                                                                dataSource={breakHistory}
                                                                                columns={breakColumns}
                                                                                rowKey="breakId"
                                                                                pagination={{ pageSize: 10 }}
                                                                                className="table-hover"
                                                                                />
                                                                            ) : (
                                                                                <>
                                                                                <div className="text-center">
                                                                                    <p>Mola kayıtları bulunamadı</p>
                                                                                </div>
                                                                                </>
                                                                            )}
                                                                            </Card>
                                                                    </div>
                                                                    <div className="text-center" style={{ marginTop: "20px" }}>
                                                                        <Link to={`/user-break?user=${userData.id}`} className="">
                                                                            {t('employeesDetail.viewAll')}
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
                            <FooterSection />
                        </div>

                  

                        {/* Maaş Güncelleme Modalı */}
                        <Modal
                            title={
                                <div className="d-flex align-items-center">
                                    <i className="ti ti-currency-dollar fs-4 me-2 text-primary"></i>
                                    <span>{t('employeesDetail.updateSalary')}</span>
                                </div>
                            }
                            open={isUpdateSalaryModalVisible}
                            onCancel={() => {
                                setIsUpdateSalaryModalVisible(false);
                                setNewSalaryAmount(null);
                            }}
                            footer={[
                                <Button 
                                    key="cancel" 
                                    onClick={() => {
                                        setIsUpdateSalaryModalVisible(false);
                                        setNewSalaryAmount(null);
                                    }}
                                >
                                    {t('employeesDetail.cancel')}
                                </Button>,
                                <Button 
                                    key="submit" 
                                    type="primary" 
                                    loading={isUpdatingSalary}
                                    onClick={handleUpdateSalary}
                                    disabled={!newSalaryAmount || newSalaryAmount <= 0}
                                >
                                    {t('employeesDetail.update')}
                                </Button>
                            ]}
                            width={500}
                        >
                            <div className="salary-update-form">
                                <div className="current-salary mb-4 p-4 bg-light rounded-3 border">
                                    <h6 className="text-muted mb-3">{t('employeesDetail.currentSalary')}</h6>
                                    <h3 className="d-flex align-items-center mb-0">
                                        <span className="currency-symbol me-2">{currencies.find(c => c.value === selectedCurrency)?.symbol}</span>
                                        <span className="fw-bold">
                                            {salaries.length > 0 ? salaries.find(salary => salary.isActive)?.amount.toLocaleString('tr-TR') : '0'}
                                        </span>
                                    </h3>
                                </div>

                                <div className="new-salary">
                                    {/* <h6 className="text-muted mb-3">{t('employeesDetail.newSalary')}</h6> */}
                                    <div className="row g-3">
                                        {/* <div className="col-md-4">
                                            <label className="form-label small text-muted">{t('employeesDetail.currency')}</label>
                                            <select 
                                                className="form-select"
                                                value={selectedCurrency}
                                                onChange={(e) => setSelectedCurrency(e.target.value)}
                                            >
                                                {currencies.map(currency => (
                                                    <option key={currency.value} value={currency.value}>
                                                        {currency.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div> */}
                                        <div className="col-md-12">
                                            <label className="form-label small text-muted">{t('employeesDetail.newSalaryAmount')}</label>
                                            <div className="input-group">
                                                <span className="input-group-text">
                                                    {currencies.find(c => c.value === selectedCurrency)?.symbol}
                                                </span>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-lg"
                                                    placeholder="0.00"
                                                    value={newSalaryAmount || ''}
                                                    onChange={(e) => setNewSalaryAmount(Number(e.target.value))}
                                                    min="0"
                                                    step="0.01"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Modal>

                        {/* Onay Modalı */}
                        <Modal
                            title={
                                <div className="d-flex align-items-center">
                                    <i className="ti ti-alert-triangle fs-4 me-2 text-warning"></i>
                                    <span>{t('employeesDetail.salaryChangeConfirmation')}</span>
                                </div>
                            }
                            open={isConfirmModalVisible}
                            onCancel={() => setIsConfirmModalVisible(false)}
                            footer={[
                                <Button 
                                    key="cancel" 
                                    onClick={() => setIsConfirmModalVisible(false)}
                                >
                                    {t('employeesDetail.noSalaryChange')}
                                </Button>,
                                <Button 
                                    key="submit" 
                                    type="primary" 
                                    loading={isUpdatingSalary}
                                    onClick={handleConfirmUpdate}
                                >
                                    {t('employeesDetail.yesSalaryChange')}
                                </Button>
                            ]}
                            width={500}
                        >
                            {calculateSalaryChange() && (
                                <div className="confirmation-content">
                                    <div className="alert alert-warning">
                                        <div className="d-flex align-items-center mb-3">
                                            <i className="ti ti-info-circle fs-4 me-2"></i>
                                            <span className="fw-medium">{t('employeesDetail.salaryChangeConfirmation')}</span>
                                        </div>
                                        <p className="mb-2">
                                            {t('employeesDetail.salaryIs')}
                                            <strong>{currencies.find(c => c.value === selectedCurrency)?.symbol}{salaries[0].amount.toLocaleString('tr-TR')}</strong>{' '}
                                            {t('employeesDetail.to')}
                                            <strong>{currencies.find(c => c.value === selectedCurrency)?.symbol}{newSalaryAmount?.toLocaleString('tr-TR')}</strong>{' '}
                                            {calculateSalaryChange()?.isIncrease ? t('employeesDetail.increase') : t('employeesDetail.decrease')} {t('employeesDetail.areYouSure')}
                                        </p>
                                        <div className="d-flex align-items-center mt-3">
                                            <span className={`badge p-2 ${
                                                calculateSalaryChange()?.isIncrease 
                                                ? 'bg-success-subtle text-success' 
                                                : 'bg-danger-subtle text-danger'
                                            }`}>
                                                <i className={`ti ti-trending-${calculateSalaryChange()?.isIncrease ? 'up' : 'down'} me-1`}></i>
                                                {calculateSalaryChange()?.isIncrease ? '+' : '-'}
                                                {Math.abs(Number(calculateSalaryChange()?.percentage))}%
                                            </span>
                                            <span className="mx-2 text-muted">•</span>
                                            <span className="text-muted">
                                                {t('employeesDetail.difference')}: {currencies.find(c => c.value === selectedCurrency)?.symbol}{calculateSalaryChange()?.difference}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Modal>

                        {/* AdminLeaveModal */}
                        <AdminLeaveModal
                            open={isLeaveModalVisible}
                            onClose={() => setIsLeaveModalVisible(false)}
                            onSubmit={handleLeaveSubmit}
                            selectedEmployeeId={Number(id)}
                        />
                    </>
                )}
            </div>
            <Modal
                title={
                <div className="d-flex align-items-center">
                    <h4 className="modal-title me-2 mb-0">
                        {t('employeesDetail.editEmployee')}
                    </h4>
                </div>
                }
                open={isModalOpen}
                onCancel={handleCancel}
                width={800}
                footer={[
                <button
                    key="cancel"
                    type="button"
                    className="btn btn-outline-light border me-2"
                    onClick={handleCancel}
                >
                    {t('employeesDetail.cancel')}
                </button>,
                <button
                    key="submit"
                    type="button"
                    onClick={handleFormSubmit}
                    className="btn btn-primary"
                >
                    {t('employeesDetail.save')}
                </button>
                ]}
            >
                {renderModalContent()}
            </Modal>
        </div>
    );
};

export default EmployeeDetails

export const TicketCard = ({ ticketid, ticketmaintitle, tickettitle, ticketstatus, ticketpriority, ticketdate }:
    { ticketid: number, ticketmaintitle: string, tickettitle: string, ticketstatus: string, ticketpriority: string, ticketdate: string }) => {

    const getStatusBadgeClass = (status: string) => {
        switch (status) {
            case "Açık":
                return "badge bg-outline-pink"; // Pembe
            case "Beklemede":
                return "badge bg-outline-warning"; // Sarı
            case "Çözümlendi":
                return "badge bg-outline-purple"; // Mor
            default:
                return "badge bg-outline-secondary"; // Gri
        }
    };

    const getPriorityBadgeClass = (priority: string) => {
        switch (priority) {
            case "Yüksek":
                return "badge bg-danger"; // Kırmızı
            case "Orta":
                return "badge bg-warning"; // Sarı
            case "Düşük":
                return "badge bg-success"; // Yeşil
            default:
                return "badge bg-secondary"; // Gri
        }
    };

    return (
        <div className="card p-3">
            <div className="d-flex justify-content-between align-items-center">
                <h6 className="text-info fw-medium mb-0">{ticketmaintitle}</h6>
                <span className={`badge ${getPriorityBadgeClass(ticketpriority)} d-inline-flex align-items-center`}>
                    <i className="ti ti-circle-filled fs-6 me-1" />
                    {ticketpriority}
                </span>
            </div>

            <div className="d-flex justify-content-between align-items-center mt-2">
                <Link to={`/tickets/ticket-details/${ticketid}`} className="fw-semibold text-dark">
                    {tickettitle}
                </Link>
                <span className={`badge ${getStatusBadgeClass(ticketstatus)} d-inline-flex align-items-center`}>
                    <i className="ti ti-circle-filled fs-6 me-1" /> {ticketstatus}
                </span>
            </div>

            <div className="d-flex justify-content-between align-items-center text-muted mt-2">
                <span className="badge badge-info rounded-pill">BIL - {ticketid}</span>
                <small>
                    <i className="ti ti-calendar-bolt me-1" /> {ticketdate}
                </small>
            </div>
        </div>
    );
};
